@if (visible) {
  <div class="canvas-import">
    <div class="canvas-import__overlay" (click)="annuler.emit()"></div>
    <div class="canvas-import__panel" role="dialog" aria-modal="true">
      <div class="canvas-import__header">
        <div>
          <p class="canvas-import__eyebrow">Import depuis {{ source }}</p>
          <h3>Associer les opérations importées</h3>
        </div>
        <button type="button" class="canvas-import__close" aria-label="Fermer" (click)="annuler.emit()">&times;</button>
      </div>
      <div class="canvas-import__body">
        <p class="canvas-import__info">
          <strong>{{ lignes.length }}</strong> opération(s) importée(s)
          @if (nbDejaTraitees > 0) {
            &middot; <strong class="info-deja">{{ nbDejaTraitees }} déjà pointée(s)</strong>
            <label class="toggle-deja">
              <input type="checkbox" [(ngModel)]="afficherDejaTraitees" />
              Afficher
            </label>
          }
          &middot; <strong>{{ nbAssociations }}</strong> seront pointées.
          Vérifiez et ajustez les associations avant de valider.
          @if (nbLignesMoisPrecedentDisponibles > 0) {
            <button type="button" class="btn-charger-jour" (click)="chargerMoisPrecedent()">Charger mois précédent</button>
          }
        </p>
        <div class="outils-import">
          <div class="outils-import__filtres">
            <details #selecteurTypes class="selecteur-types">
              <summary>
                Sélection par type
                <span>{{ nbTypesAvecSelection }}/{{ typesDisponibles.length }}</span>
              </summary>
              <div class="selecteur-types__menu" role="group" aria-label="Sélectionner les opérations par type">
                @for (type of typesDisponibles; track trackByType($index, type)) {
                  <label>
                    <input
                      type="checkbox"
                      [ngModel]="type.selectionnables > 0 && type.selectionnees === type.selectionnables"
                      (ngModelChange)="selectionnerType(type.cle, $event)"
                      [indeterminate]="type.selectionnees > 0 && type.selectionnees < type.selectionnables"
                      [disabled]="type.selectionnables === 0"
                      />
                    <span>{{ type.libelle }}</span>
                    <small>{{ type.selectionnees }}/{{ type.selectionnables }}</small>
                  </label>
                }
              </div>
            </details>
            <span class="outils-import__compteur">
              {{ rowsVisibles.length }} ligne(s) affichée(s)
            </span>
          </div>
          <div class="outils-import__selection">
            <button
              type="button"
              class="btn-selection-masse"
              (click)="selectionnerLignesVisibles(true)"
              [disabled]="nbLignesModifiablesVisibles === 0 || nbLignesSelectionneesVisibles === nbLignesModifiablesVisibles"
            >Tout sélectionner</button>
            <button
              type="button"
              class="btn-selection-masse btn-selection-masse--exclure"
              (click)="selectionnerLignesVisibles(false)"
              [disabled]="nbLignesSelectionneesVisibles === 0"
            >Tout désélectionner</button>
          </div>
        </div>
        <div class="table-import-wrapper">
          <table class="table-import">
            <thead>
              <tr>
                <th class="col-ignore" [attr.aria-sort]="ariaTri('SELECTION')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('SELECTION')" title="Trier par sélection">
                    Importer <span class="indicateur-tri">{{ indicateurTri('SELECTION') }}</span>
                  </button>
                </th>
                <th class="col-date" [attr.aria-sort]="ariaTri('DATE')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('DATE')">
                    Date d'opération <span class="indicateur-tri">{{ indicateurTri('DATE') }}</span>
                  </button>
                </th>
                <th class="col-date" [attr.aria-sort]="ariaTri('DATE_VALEUR')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('DATE_VALEUR')">
                    Date de valeur <span class="indicateur-tri">{{ indicateurTri('DATE_VALEUR') }}</span>
                  </button>
                </th>
                <th class="col-libelle-import" [attr.aria-sort]="ariaTri('LIBELLE')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('LIBELLE')">
                    Libellé import <span class="indicateur-tri">{{ indicateurTri('LIBELLE') }}</span>
                  </button>
                </th>
                <th class="col-type" [attr.aria-sort]="ariaTri('TYPE')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('TYPE')">
                    Type <span class="indicateur-tri">{{ indicateurTri('TYPE') }}</span>
                  </button>
                </th>
                <th class="col-montant" [attr.aria-sort]="ariaTri('MONTANT')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('MONTANT')">
                    Montant <span class="indicateur-tri">{{ indicateurTri('MONTANT') }}</span>
                  </button>
                </th>
                <th class="col-association" [attr.aria-sort]="ariaTri('ASSOCIATION')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('ASSOCIATION')">
                    Opération planifiée associée <span class="indicateur-tri">{{ indicateurTri('ASSOCIATION') }}</span>
                  </button>
                </th>
                <th class="col-confiance" [attr.aria-sort]="ariaTri('CONFIANCE')">
                  <button type="button" class="btn-tri-colonne" (click)="trierPar('CONFIANCE')" title="Trier par confiance">
                    ∼ <span class="indicateur-tri">{{ indicateurTri('CONFIANCE') }}</span>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              @if (rowsVisibles.length === 0) {
                <tr>
                  <td colspan="8" class="aucune-ligne-import">
                    Aucune opération à afficher.
                  </td>
                </tr>
              }
              @for (row of rowsVisibles; track row) {
                <tr
                  [class.row--ignoree]="row.ignore && !row.dejaTraitee"
                  [class.row--deja-traitee]="row.dejaTraitee"
                  >
                  <td class="col-ignore">
                    <label class="selection-ligne">
                      <input
                        type="checkbox"
                        [ngModel]="!row.ignore && !row.dejaTraitee"
                        (ngModelChange)="definirLigneSelectionnee(row, $event)"
                        [disabled]="row.dejaTraitee"
                        [attr.aria-label]="'Importer : ' + row.ligne.libelle"
                        title="Importer cette ligne"
                        />
                      <span class="selection-ligne__texte">Importer</span>
                    </label>
                  </td>
                  <td class="col-date col-date-operation" data-label="Date d'opération">{{ row.ligne.dateStr }}</td>
                  <td class="col-date col-date-valeur" data-label="Date de valeur">{{ row.ligne.dateValeurStr || '—' }}</td>
                  <td class="col-libelle-import">
                    <span class="libelle-import">{{ row.ligne.libelle }}</span>
                    @if (row.ligne.lieu) {
                      <span class="lieu-import">{{ row.ligne.lieu }}</span>
                    }
                    @if (estOperationAVenir(row.ligne)) {
                      <span class="badge-a-venir">À venir — non pointée</span>
                    }
                  </td>
                  <td class="col-type" data-label="Type">
                    <span class="type-label">{{ row.ligne.typeLabel || 'Sans type' }}</span>
                    @if (row.ligne.numeroCheque) {
                      <span class="cheque-ref">N°{{ row.ligne.numeroCheque }}</span>
                    }
                  </td>
                  <td class="col-montant"
                    [class.montant-entree]="row.ligne.typeOp === 'ENTREE'"
                    [class.montant-sortie]="row.ligne.typeOp === 'SORTIE'"
                    >
                    {{ formatterMontant(row.ligne.montantBrut) }}
                  </td>
                  <td class="col-association" data-label="Opération associée">
                    @if (row.dejaTraitee) {
                      <span class="badge-deja-traitee" [title]="'Opération réelle du ' + (row.opReelleExistante?.dateOperation | date:'dd/MM/yyyy') + ' : ' + row.opReelleExistante?.libelle">
                        ✓ Déjà pointée ({{ row.opReelleExistante?.dateOperation | date:'dd/MM' }})
                      </span>
                    } @else {
                      @if (row.creerNouvelleOp) {
                        <div class="badge-creation">
                          <span class="badge-nouvelle-op">➕ Nouvelle opération réelle</span>
                          <button type="button" class="btn-annuler-creation" (click)="basculerCreation(row)" title="Annuler la création">&times;</button>
                        </div>
                      } @else {
                        <div class="select-avec-creation">
                          <select [(ngModel)]="row.operationSelectionneeId" [attr.disabled]="row.ignore || null" [attr.aria-label]="'Opération associée à ' + row.ligne.libelle">
                            <option [ngValue]="null">— Non associée (ignorer) —</option>
                            @for (op of opsCompatibles(row.ligne); track op) {
                              <option
                                [ngValue]="effectiveOperationId(op, row.ligne)"
                                [disabled]="isOpDejaSelectionnee(effectiveOperationId(op, row.ligne), row)">
                                {{ op.libelle }} ({{ formatterMontant(montantOpCeMois(op, row.ligne)) }}){{ isOpDejaSelectionnee(effectiveOperationId(op, row.ligne), row) ? ' — déjà associée' : '' }}
                              </option>
                            }
                          </select>
                          @if (!row.ignore) {
                            <button type="button" class="btn-creer-op"
                              (click)="basculerCreation(row)"
                            title="Créer une nouvelle opération réelle avec ces données">➕</button>
                          }
                        </div>
                      }
                    }
                  </td>
                  <td class="col-confiance" data-label="Confiance">
                    <span
                      class="badge-confiance"
                      [class.badge-confiance--haute]="labelConfiance(row.scoreConfiance) === 'haute'"
                      [class.badge-confiance--moyenne]="labelConfiance(row.scoreConfiance) === 'moyenne'"
                      [class.badge-confiance--faible]="labelConfiance(row.scoreConfiance) === 'faible'"
                      [title]="'Score : ' + row.scoreConfiance"
                      >
                      {{ labelConfiance(row.scoreConfiance) === 'haute' ? '✓✓' : labelConfiance(row.scoreConfiance) === 'moyenne' ? '✓' : '?' }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="canvas-import__actions">
        <button type="button" class="btn-valider-import" (click)="valider()" [disabled]="nbAssociations === 0">
          ✅ Pointer {{ nbAssociations }} opération(s)
        </button>
        <button type="button" class="btn-annuler-import" (click)="annuler.emit()">Annuler</button>
      </div>
    </div>
  </div>
}
